/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Audit_Details_Spoken_Declined_After_Reask_DescInputs */



/**
* | output |
* | --- |
* | "Spoken decline (after re-ask): {tool}" |
*
* @param {Audit_Details_Spoken_Declined_After_Reask_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_spoken_declined_after_reask_desc = /** @type {((inputs: Audit_Details_Spoken_Declined_After_Reask_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Spoken_Declined_After_Reask_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mündliche Ablehnung (nach Rückfrage): ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Spoken decline (after re-ask): ${i?.tool}`)
});